const SPACE_DATA = {
		"u6999116":  [{space_js: "//slddarj.szshyckj.com/source/to/nwwwx/x_n.js", space_src: "baidujs", space_type: "inters", space_id: "u6999116"}],
		"u6999117":  [{space_js: "//slddarj.szshyckj.com/common/upo_xxxy_y_q.js", space_src: "baidujs", space_type: "native", space_id: "u6999117"}],
		"u6999118":  [{space_js: "//slddarj.szshyckj.com/production/v/source/qpyyy/production/z_zs.js", space_src: "baidujs", space_type: "native", space_id: "u6999118"}],
		"u6999119":  [{space_js: "//slddarj.szshyckj.com/site/w/openjs/rqzz/static/za_a/production/z.js", space_src: "baidujs", space_type: "native", space_id: "u6999119"}],
		"u6999120":  [{space_js: "//slddarj.szshyckj.com/production/oj/openjs/ir-r-rsy/resource/p.js", space_src: "baidujs", space_type: "native", space_id: "u6999120"}],
};
export const SPACE_MAP = {
	Home_inter:  SPACE_DATA["u6999116"],
	Home_native:  SPACE_DATA["u6999117"],
	Home_banner:  SPACE_DATA["u6999118"],
	Detail_inter:  SPACE_DATA["u6999116"],
	Detail_native:  SPACE_DATA["u6999117"],
	Detail_banner:  SPACE_DATA["u6999118"],
	List_native:  SPACE_DATA["u6999117"],
	List_banner:  SPACE_DATA["u6999118"],
	Result_inter:  SPACE_DATA["u6999116"],
	Result_native:  SPACE_DATA["u6999117"],
	Result_banner:  SPACE_DATA["u6999118"],
	Result_native_center1:  SPACE_DATA["u6999119"],
	Result_native_center2:  SPACE_DATA["u6999120"],
}
export const ALL_SPACE_MAP = {
    H5_SHBZ_VO_1 : {
		Home_inter:  SPACE_DATA["u6999116"],
		Home_banner:  SPACE_DATA["u6999117"],
		Home_native:  SPACE_DATA["u6999118"],
		Detail_inter:  SPACE_DATA["u6999116"],
		Detail_banner:  SPACE_DATA["u6999117"],
		Detail_native:  SPACE_DATA["u6999118"],
		List_banner:  SPACE_DATA["u6999117"],
		List_native:  SPACE_DATA["u6999118"],
		Result_inter:  SPACE_DATA["u6999116"],
		Result_banner:  SPACE_DATA["u6999117"],
		Result_native:  SPACE_DATA["u6999118"],
		Result_native_center1:  SPACE_DATA["u6999119"],
		Result_native_center2:  SPACE_DATA["u6999120"],
    },
    DEFAULT : {
		Home_inter:  SPACE_DATA["u6999116"],
		Home_native:  SPACE_DATA["u6999117"],
		Home_banner:  SPACE_DATA["u6999118"],
		Detail_inter:  SPACE_DATA["u6999116"],
		Detail_native:  SPACE_DATA["u6999117"],
		Detail_banner:  SPACE_DATA["u6999118"],
		List_native:  SPACE_DATA["u6999117"],
		List_banner:  SPACE_DATA["u6999118"],
		Result_inter:  SPACE_DATA["u6999116"],
		Result_native:  SPACE_DATA["u6999117"],
		Result_banner:  SPACE_DATA["u6999118"],
		Result_native_center1:  SPACE_DATA["u6999119"],
		Result_native_center2:  SPACE_DATA["u6999120"],
    },
};
